import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";


// TODO: CRIO_TASK_MODULE_REGISTER - Add Target container ID (refer public/index.html)

import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/system";
import theme from "./theme";


ReactDOM.render(
  <React.StrictMode>

    <BrowserRouter>
    <ThemeProvider theme ={theme}>
      <SnackbarProvider
          maxSnack={1}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          preventDuplicate
        >
          <App />
        </SnackbarProvider>
        </ThemeProvider>
     </BrowserRouter>
  </React.StrictMode>,

   document.getElementById('root')


);
